// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"V--z","subtitle":"W--z","wrapper":"X--z","leftArrow":"Y--z","rightArrow":"Z--z"};